import axios from 'axios';
import authHeader from './auth-header';
axios.defaults.baseURL =  process.env.VUE_APP_API_BASE
axios.defaults.timeout = 100000
class UserService {
    _getRequest($path, $params) {
        return axios.get($path + '?XDEBUG_SESSION=PHPSTORM', { headers: authHeader(), params: $params });
    }
    _postRequest($path, $params) {
        return axios.post($path, $params,{headers: authHeader()})
    }
    vendorStatistics() {
        return this._getRequest('/vendor/statistics')
    }
    vendorProducts() {
        return this._getRequest('/vendor/product/list')
    }
    vendorOrders(per_page, paged, status) {
        return this._getRequest('/vendor/order/list', {per_page, paged, status})
    }
    viewOrder(order_id) {
        return this._getRequest('/vendor/view-order/' + order_id + '?XDEBUG_SESSION=PHPSTORM')
    }
    vendorTransactions(per_page, paged) {
        return this._getRequest('/vendor/transactions', {per_page, paged})
    }
    vendorOrderStatusesCount() {
        return this._getRequest('/vendor/order-statuses-count')
    }
    vendorGetPaymentMethod() {
        return this._getRequest('/vendor/payment-method')
    }
    getWithdrawData() {
        return this._getRequest('/vendor/withdraw-data')
    }
    getWalletData() {
        return this._getRequest('/vendor/wallet/balance')
    }
    getTransactions(unit, per_page, paged) {
        return this._getRequest('/vendor/wallet/transactions', {unit, per_page, paged})
    }
    walletTransfer(source, destination, amount) {
        return this._postRequest('/vendor/wallet/transfer', {source, destination, amount})
    }
    getWithdrawList() {
        return this._getRequest('/vendor/withdraw-list')
    }
    vendorUpdatePaymentMethod(bank_name, account_number, card_number, sheba_number) {
        return this._postRequest('/vendor/update-payment-method', {bank_name, account_number, card_number, sheba_number})
    }
    vendorProfileUpdate($params) {
        return this._postRequest('/vendor/profile/update', $params)
    }
    vendorWithdrawRequest($type) {
        return this._postRequest('/vendor/withdraw-request', {type: $type})
    }
}
export default new UserService();
